"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eventStack = require("@semantic-ui-react/event-stack");

var _default = _eventStack.instance;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/semantic-ui-react/dist/commonjs/lib/eventStack/index.js
// module id = 2217
// module chunks = 1